import type { SVGAttributes } from 'react';

export function ExportIcon(props: SVGAttributes<SVGSVGElement>) {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" fill="none" {...props} viewBox="0 0 16 16">
			<path
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				d="m8.667 7.333 5.466-5.466m.534 2.666v-3.2h-3.2m-4.134 0H6C2.667 1.333 1.333 2.667 1.333 6v4c0 3.333 1.334 4.667 4.667 4.667h4c3.333 0 4.667-1.334 4.667-4.667V8.667"
			/>
		</svg>
	);
}
